import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebaseSetup";

export interface LegalsContent {
  privacyPolicy: string | null;
  imprint: string | null;
}

function latestVersionContent(versions: unknown): string | null {
  if (!Array.isArray(versions) || versions.length === 0) return null;
  let latest: Record<string, unknown> | null = null;
  let highest = -1;
  for (const version of versions) {
    if (version && typeof version === "object") {
      const v = version as Record<string, unknown>;
      const num = typeof v.version === "number" ? v.version : 0;
      if (num > highest) {
        highest = num;
        latest = v;
      }
    }
  }
  return latest && typeof latest.content === "string" ? latest.content : null;
}

export async function fetchLegals(): Promise<LegalsContent> {
  const snap = await getDoc(doc(db, "legals", "1"));
  const data = snap.data() ?? {};
  return {
    privacyPolicy: latestVersionContent(data.privacyPolicyVersions),
    imprint: latestVersionContent(data.imprintVersions),
  };
}
